import script from "./ProjectForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectForm.vue?vue&type=style&index=0&id=6418a9c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6418a9c3"]])

export default __exports__